window.addEventListener('load', (event) => {
    var template = document.querySelector('body');
    var page = location.pathname;
    if ((template.classList.contains('template-404')) && (page.includes('/products/'))) {
        var modal = document.querySelector('#PopupModal-404');
        if (modal) {
            modal.setAttribute('open', '');
        }
    }
});